"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleRowPrincipalAmountFormula = void 0;
exports.getScheduleRowPrincipalAmount = getScheduleRowPrincipalAmount;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of ScheduleRowPaymentAmount formala implementation names
 */
var ScheduleRowPrincipalAmountFormula;
(function (ScheduleRowPrincipalAmountFormula) {
    ScheduleRowPrincipalAmountFormula[ScheduleRowPrincipalAmountFormula["DEFAULT"] = 0] = "DEFAULT";
})(ScheduleRowPrincipalAmountFormula || (exports.ScheduleRowPrincipalAmountFormula = ScheduleRowPrincipalAmountFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getScheduleRowPrincipalAmount(formula) {
    switch (formula) {
        default:
            return default_scheduleRowPrincipalAmount;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_scheduleRowPrincipalAmount = (params) => {
    if (typeof params.currentRow === 'object') {
        if (typeof params.currentRow.paymentAmount === 'number' && typeof params.currentRow.interestAmount === 'number') {
            return (0, general_formulas_1.toFixedNumber)(params.currentRow.paymentAmount - params.currentRow.interestAmount, 2);
        }
    }
    return NaN;
};
//# sourceMappingURL=schedule-row-principal-amount-formula.js.map